<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isNotifM">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MSG"]["MEM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isNotifM = !bool_isNotifM">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MSG"]["MSGT"]}} :</label>
                                        <CInput maxlength="200" vertical size="sm" :value="obj_Comm.CNT" @change="v => obj_Comm.CNT = v" />
                                    </CCol>

                                </CRow>
                                <CRow>
                                    <CCol>
                                        <label class="col-form-label-sm">{{this.getLanguage["MSG"]["MSGC"]}} :</label>
                                        <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_Comm.CNM" @change="TextValueChange('CNM',$event)" v-shortkey.avoid />
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="sentCommisionMainSwitch()">
                                        {{this.getLanguage["BTN"]["SEND"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--Arrange columns popup-->
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="(arr_FV['CT'] == 1 ? needResetWLHeaders : needResetTHeaders)">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-if="arr_FV['CT'] == 1" v-model="report_WLHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in report_WLHeaders" :key="header" scope="col" class="list-group-item p-2">                                            
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                            </template>
                                            <template v-else-if="header == 'PC'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['C']}}
                                                <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                            </template>
                                            <template v-else-if="header == 'GC'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['GCAT']}}
                                            </template>
                                            <template v-else-if="header == 'GP'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['GPROV']}}
                                            </template>
                                            <template v-else-if="header == 'WL'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['GWL']}}
                                                <i @click="setSortTable('WinLoseAmount')" class="sortlogo" :class="setSortLogo('WinLoseAmount')"></i>
                                            </template>
                                            <template v-else-if="header == 'R'">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['RB']}}
                                            </template>
                                            <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage['PM']['RB']}} / {{getLanguage['BTN']['SV']}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                    <draggable v-else v-model="report_THeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in report_THeaders" :key="header" scope="col" class="list-group-item p-2">                                            
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                            </template>
                                            <template v-else-if="header == 'PC'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['C']}}
                                                <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                            </template>
                                            <template v-else-if="header == 'GC'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['GCAT']}}
                                            </template>
                                            <template v-else-if="header == 'GP'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['GPROV']}}
                                            </template>
                                            <template v-else-if="header == 'TO'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['TO']}}
                                                <i @click="setSortTable('TurnoverAmount')" class="sortlogo" :class="setSortLogo('TurnoverAmount')"></i>
                                            </template>
                                            <template v-else-if="header == 'C'">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['CCP']}}
                                            </template>
                                            <template v-else-if="header == 'CS' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage['PM']['CCP']}} / {{getLanguage['BTN']['SV']}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["SMB"]["PMCR"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="agentGroupChange"
                                                  v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGI']"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['MB']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["GCAT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_gamecategory"
                                            :placeholder="this.utilGetDDLanguage('PM.GCAT')"
                                            @input="gameCategoryDropDownList"
                                            v-model="arr_FV['GCI']" />
                            </div>
                            <div class="searchCol">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["GPROV"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_gameprovider"
                                            :placeholder="this.utilGetDDLanguage('PM.GPROV')"
                                            @input="GetGameDropDownList"
                                            v-model="arr_FV['GPI']" />
                            </div>
                            <div class="searchCol">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["GG"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_game"
                                            :placeholder="this.utilGetDDLanguage('PM.GG')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="arr_FV['GI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["C"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('PM.C')"
                                            v-model="arr_FV['CI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["WLOT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_commissiontype"
                                            :clearable="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.TWG')"
                                            :auto-load-root-options="false"
                                            v-model="arr_FV['CT']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <!-- Win / Loss -->
            <div class='table-wrapper' v-if="arr_FV['CT'] == 1">
                <header class="table-header">
                    <strong>{{this.getLanguage["SMB"]["CAP"]}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetWLHeaders">
                            <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="report_WLHeaders" tag="tr">
                                <th v-for="header in report_WLHeaders" :key="header" scope="col" :class="renderClassName(header)">                                    
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                    </template>                                    
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['C']}}
                                        <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                    </template>
                                    <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GCAT']}}
                                    </template>
                                    <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                    </template>
                                    <template v-else-if="header == 'WL'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GWL']}}
                                        <i @click="setSortTable('WinLoseAmount')" class="sortlogo" :class="setSortLogo('WinLoseAmount')"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['RB']}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['RB']}} / {{getLanguage['BTN']['SV']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="report_WLHeaders" tag="tr">
                                <th v-for="header in report_WLHeaders" :key="header" scope="col" :class="renderClassName(header)">                                                                                                                                                                                                                                                               
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['C']}}
                                        <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                    </template>
                                    <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GCAT']}}
                                    </template>
                                    <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                    </template>
                                    <template v-else-if="header == 'WL'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['GWL']}}
                                        <i @click="setSortTable('WinLoseAmount')" class="sortlogo" :class="setSortLogo('WinLoseAmount')"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['RB']}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage['PM']['RB']}} / {{getLanguage['BTN']['SV']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,1)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="(arr_FV.AGI == null || arr_FV.AGI == 0) && (arr_FV.SAGI == null || arr_FV.SAGI == 0)">{{this.getLanguage['GL']['PSAA']}}</td>
                        <tr v-if="checkModuleAccess2(constAccessType.edit) && ((arr_FV.AGI != null && arr_FV.AGI != 0) || (arr_FV.SAGI != null && arr_FV.SAGI != 0))">                            
                            <td v-for="header in report_WLHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'"></template>
                                <template v-else-if="header == 'BN'"></template>
                                <template v-else-if="header == 'PC'"></template>
                                <template v-else-if="header == 'U'"></template>
                                <template v-else-if="header == 'WL'"></template>
                                <template v-else-if="header == 'R'"></template>                                
                                <template v-else-if="header == 'RS' && ((isSENS == 1 && arr_FV.AGI == curAGI) || isSENS == 0)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(dec_commAll,2)" @change="v => {dec_commAll = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary" style="min-width:95px;" @click="updateAllCommission()">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['SA']}}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ str_commAll_err }}</span>
                                </template>
                                <template v-else-if="header == 'RS' && (isSENS == 1 && arr_FV.AGI != curAGI)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(dec_commAll,2)" @change="v => {dec_commAll = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['SA']}}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ str_commAll_err }}</span>
                                </template>
                                <template v-else-if="header == 'ACT' && ((isSENS == 1 && arr_FV.AGI == curAGI) || isSENS == 0)">
                                    <CButton size="sm" block color="primary" class="btn" @click="popUpNotif(0)" :disabled="bool_sendAllDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['SRTA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NSRTA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="bool_sendAllLoading"></div>
                                    </CButton>
                                </template>
                                <template v-else-if="header == 'ACT' && (isSENS == 1 && arr_FV.AGI != curAGI)">
                                    <CButton size="sm" block color="primary" class="btn" :disabled="bool_sendAllDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['SRTA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NSRTA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="bool_sendAllLoading"></div>
                                    </CButton>
                                </template>
                            </td>
                        </tr>
                        <tr v-if=" arr_PTurnover.length == 0 && ((arr_FV.AGI != null && arr_FV.AGI != 0) || (arr_FV.SAGI != null && arr_FV.SAGI != 0))">
                            <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                        </tr>
                        <tr v-for="(data,index) in arr_PTurnover" v-if="(arr_FV.AGI != null && arr_FV.AGI != 0) || (arr_FV.SAGI != null && arr_FV.SAGI != 0)" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                            <td v-for="header in report_WLHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</span>
                                </template>
                                <template v-else-if="header == 'PC'">
                                    {{ data.CISOC }}
                                </template>
                                <template v-else-if="header == 'U' && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <span class="grid-line">

                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1" @click="CheckingMember(data.AGI,data.MI)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'U' && (isSENS == 1 && data.AGI != curAGI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                    {{ data.GCN }}
                                </template>
                                <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                    {{ renderProviderName(data.GPN) }}
                                </template>
                                <template v-else-if="header == 'WL'">
                                    <span :class="(data.WLA<0 ? 'redfont' : '')">{{ formatNumber(data.WLA, 2, data.CS) }}</span>
                                </template>
                                <template v-else-if="header == 'R'">
                                    <span class="grid-line">{{ data.CP.toFixed(2) }}%</span>
                                    <span class="grid-line">{{ formatNumber(data.CA, 2, data.CS) }}</span>
                                </template>
                                <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(data.dec_comm,2)" @change="v => {data.dec_comm = RemoveThousandSeparator(v,2);}" :disabled="disableUpdate(data.WLA)">                                        
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary" style="min-width:95px;" @click="updateCommission(index)" :disabled="disableUpdate(data.WLA)">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['UPD'] }}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ data.str_comm_err }}</span>
                                </template>
                                <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(data.dec_comm,2)" @change="v => {data.dec_comm = RemoveThousandSeparator(v,2);}" :disabled="disableUpdate(data.WLA)">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary" :disabled="disableUpdate(data.WLA)">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['UPD'] }}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ data.str_comm_err }}</span>
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <CButton size="sm" type="submit" color="primary" @click="popUpNotif(index)" :disabled="data.bool_sendDisable || disableUpdate(data.WLA)">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GSR']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGSR']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                    </CButton>
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                    <CButton size="sm" type="submit" color="primary" :disabled="data.bool_sendDisable || disableUpdate(data.WLA)">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GSR']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGSR']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                    </CButton>
                                </template>
                            </td>                                                     
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Turnover -->
            <div class='table-wrapper' v-else>
                <header class="table-header">
                    <strong>{{this.getLanguage["SMB"]["PMT"]}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetTHeaders">
                            <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="report_THeaders" tag="tr">
                                <th v-for="header in report_THeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['C']}}
                                        <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                    </template>
                                    <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['GCAT']}}
                                    </template>
                                    <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                    </template>
                                    <template v-else-if="header == 'TO'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['TO']}}
                                        <i @click="setSortTable('TurnoverAmount')" class="sortlogo" :class="setSortLogo('TurnoverAmount')"></i>
                                    </template>
                                    <template v-else-if="header == 'C'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['CCP']}}
                                    </template>
                                    <template v-else-if="header == 'CS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['CCP']}} / {{getLanguage['BTN']['SV']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                </th>                                
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="report_THeaders" tag="tr">
                                <th v-for="header in report_THeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['C']}}
                                        <i @click="setSortTable('CurrencyId')" class="sortlogo" :class="setSortLogo('CurrencyId')"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('MemberId')" class="sortlogo" :class="setSortLogo('MemberId')"></i>
                                    </template>
                                    <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['GCAT']}}
                                    </template>
                                    <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                    </template>
                                    <template v-else-if="header == 'TO'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['TO']}}
                                        <i @click="setSortTable('TurnoverAmount')" class="sortlogo" :class="setSortLogo('TurnoverAmount')"></i>
                                    </template>
                                    <template v-else-if="header == 'C'">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['CCP']}}
                                    </template>
                                    <template v-else-if="header == 'CS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage['PM']['CCP']}} / {{getLanguage['BTN']['SV']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header,2)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                </th>                                
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="(arr_FV.AGI == null || arr_FV.AGI == 0) && (arr_FV.SAGI == null || arr_FV.SAGI == 0)">{{this.getLanguage['GL']['PSAA']}}</td>
                        <tr v-if="checkModuleAccess2(constAccessType.edit) && ((arr_FV.AGI != null && arr_FV.AGI != 0) || (arr_FV.SAGI != null && arr_FV.SAGI != 0))" colspan="100%">                            
                            <td v-for="header in report_THeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'"></template>
                                <template v-else-if="header == 'BN'"></template>
                                <template v-else-if="header == 'PC'"></template>
                                <template v-else-if="header == 'U'"></template>
                                <template v-else-if="header == 'TO'"></template>
                                <template v-else-if="header == 'C'"></template>
                                <template v-else-if="header == 'CS' && ((isSENS == 1 && arr_FV.AGI == curAGI) || isSENS == 0)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(dec_commAll,2)" @change="v => {dec_commAll = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary" style="min-width:95px;" @click="updateAllCommission()">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['SA']}}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ str_commAll_err }}</span>
                                </template>
                                <template v-else-if="header == 'CS' && (isSENS == 1 && arr_FV.AGI != curAGI)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(dec_commAll,2)" @change="v => {dec_commAll = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['SA']}}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ str_commAll_err }}</span>
                                </template>
                                <template v-else-if="header == 'ACT' && ((isSENS == 1 && arr_FV.AGI == curAGI) || isSENS == 0)">
                                    <CButton size="sm" block color="primary" class="btn" @click="popUpNotif(0)" :disabled="bool_sendAllDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GCSA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGCSA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="bool_sendAllLoading"></div>
                                    </CButton>
                                </template>
                                <template v-else-if="header == 'ACT' && (isSENS == 1 && arr_FV.AGI == curAGI)">
                                    <CButton size="sm" block color="primary" class="btn" :disabled="bool_sendAllDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GCSA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGCSA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="bool_sendAllLoading"></div>
                                    </CButton>
                                </template>
                            </td>                            
                        </tr>
                        <tr v-if="arr_PTurnover.length == 0 && ((arr_FV.AGI != null && arr_FV.AGI != 0)  || (arr_FV.SAGI != null && arr_FV.SAGI != 0))">
                            <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                        </tr>
                        <tr v-for="(data,index) in arr_PTurnover" v-if="(arr_FV.AGI != null && arr_FV.AGI != 0)  || (arr_FV.SAGI != null && arr_FV.SAGI != 0)" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                            <td v-for="header in report_THeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span class="grid-line">{{ data.GN }}</span>
                                    <span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</span>
                                </template>
                                <template v-else-if="header == 'PC'">
                                    {{ data.CISOC }}
                                </template>
                                <template v-else-if="header == 'U' && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1" @click="CheckingMember(data.AGI,data.MI)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'U' && (isSENS == 1 && data.AGI != curAGI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'GC' && bool_showGameCategoryColumn">
                                    {{ data.GCN }}
                                </template>
                                <template v-else-if="header == 'GP' && bool_showGameProviderColumn">
                                    {{ renderProviderName(data.GPN) }}
                                </template>
                                <template v-else-if="header == 'TO'" class="tableCtnRight">
                                    {{ formatNumber(data.TA, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'C'">
                                    <span class="grid-line">{{ data.CP.toFixed(2) }}%</span>
                                    <span class="grid-line">{{ formatNumber(data.CA, 2, data.CS) }}</span>
                                </template>
                                <template v-else-if="header == 'CS' && checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(data.dec_comm,2)" @change="v => {data.dec_comm = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary" style="min-width:95px;" @click="updateCommission(index)">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['UPD'] }}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ data.str_comm_err }}</span>
                                </template>
                                <template v-else-if="header == 'CS' && checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                    <CInput type="number" placeholder="0" size="sm" class="mwidth200" :value="ThousandSeparator(data.dec_comm,2)" @change="v => {data.dec_comm = RemoveThousandSeparator(v,2);}">
                                        <template #append>
                                            <CButton size="sm" type="submit" color="primary">
                                                <span style="margin-right: 5px;">(%) {{ getLanguage['BTN']['UPD'] }}</span>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ data.str_comm_err }}</span>
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <CButton size="sm" type="submit" color="primary" @click="popUpNotif(index)" :disabled="data.bool_sendDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GSC']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGSC']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                    </CButton>
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                    <CButton size="sm" type="submit" color="primary" :disabled="data.bool_sendDisable">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['GSC']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NGSC']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                    </CButton>
                                </template>
                            </td>                            
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import { and } from 'vuelidate/lib/validators';
    import $ from 'jquery'
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },

        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_showGameProviderColumn: true,
                bool_showGameCategoryColumn: true,
                dec_commAll: 0,                
                bool_sendAllLoading: false,
                bool_sendAllDisable: true,
                bool_isNotifM: false,
                int_tempStoreID: 0,
                str_commAll_err: "",                
                arr_FV: {
                    "AGI": null,
                    "SAGI": null,
                    "GCI": null,
                    "GPI": null,
                    "GI": null,
                    "DR": {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    },
                    "MB": null,
                    "CI": null,
                    "CT": 1
                },
                obj_Comm: {
                    "AC": 1,
                    "ATAGI": "",
                    "GCI": 0,
                    "GPI": 0,
                    "GI": 0,
                    "GTS_from": this.getTodayDate(),
                    "GTS_to": this.getTodayEndDate(),
                    "CI": 0,
                    "CT": 2,
                    "CNT": "",
                    "CNM": "",
                    "R": [],
                },
                arr_PTurnover: [],
                dd_currency: [],
                dd_game: [],
                dd_gameprovider: [],
                dd_gamecategory: [],
                dd_agentgroup: [],
                dd_commissiontype: [],
                constAccessType: constAccessType,
                ddMemberList: [],
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                rtSubBrand: 0,                
                default_WLReportHeaders: ['NO','BN', 'PC', 'U', 'GC', 'GP', 'WL', 'R', 'RS', 'ACT'],
                default_TReportHeaders: ['NO','BN', 'PC', 'U', 'GC', 'GP', 'TO', 'C', 'CS', 'ACT'],
                report_WLHeaders: [],
                report_THeaders: [],
                bool_isDDMV: false, //Arrange columns popup
                needResetWLHeaders: false, //Reset WL header                
                needResetTHeaders: false, //Reset T header                
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },          
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            checkPermissionAccess2(type) {
                return this.checkModuleAccess('AMP', 'P', type);
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('PMCR', 'P', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionTurnoverList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getPromotionTurnoverList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionTurnoverList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            //var cloneParentGroup = that.deepClone(d.dropdownlist);

                            //// list filter only push in child group, do not include own group
                            //if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //    that.dd_agentgroup = [];
                            //    for (var i = 0; i < cloneParentGroup.length; i++) {
                            //        if (cloneParentGroup[i].children != undefined) {
                            //            for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //                that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //            }
                            //        }
                            //    }
                            //}

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup[0].children == undefined) {
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.arr_FV["AGI"] = that.dd_agentgroup[0].id;
                                }
                            }
                        }
                    });

                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.dd_gamecategory = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/gameProv/0/` + this.getUserInfo.AGI,
                    function (d, s) {
                        //if (s) {
                        if (s && d && d.dropdownlist) {

                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.dd_gameprovider = d.dropdownlist;

                        }
                        else {
                            that.dd_gameprovider = null;
                        }
                    });

                this.GetGameDropDownList();

                this.dd_commissiontype = [{ id: 1, label: this.getLanguage["SMB"]["WLR"]}, { id: 2, label: this.getLanguage["SMB"]["TR"] }];                
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            GetGameDropDownList() {
                this.dd_game = [];
                this.arr_FV["GI"] = null;

                var gameCategoryId = this.arr_FV["GCI"] == null ? 0 : this.arr_FV["GCI"];
                var gameProviderId = this.arr_FV["GPI"] == null ? 0 : this.arr_FV["GPI"];
                var that = this;

                if (gameCategoryId != 0 && gameProviderId != 0) {
                    this.getDataApi(`/api/dd/game/0/${gameCategoryId}/${gameProviderId}`,
                        function (d, s) {
                            if (s) {
                                that.dd_game = d.dropdownlist;

                                for (var idx = 0; idx < that.dd_game.length; idx++) {
                                    that.dd_game[idx].label = that.changeGameName(that.dd_game[idx].extra, that.dd_game[idx].label);
                                }
                            }
                        });
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            changeGameName(provider, item) {
                if (provider in this.getLanguage && item in this.getLanguage[provider])
                    item = this.getLanguage[provider][item];

                return item;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.arr_FV["AGI"]) {
                        agi = this.arr_FV["AGI"].split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            getPromotionTurnoverList() {
                if ((this.arr_FV["AGI"] == null || this.arr_FV["AGI"] == 0) && (this.arr_FV["SAGI"] == null || this.arr_FV["SAGI"] == 0)) {
                    return;
                }
                this.bool_fullLoading = true;                
                // this.bool_showGameProviderColumn = true;
                // this.bool_showGameCategoryColumn = true;                
                
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        //"f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "f.ATAGI=" + (this.arr_FV["SAGI"] != null ? "4-" + this.arr_FV["SAGI"] : (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"])) +
                        "&f.GCI=" + (this.arr_FV["GCI"] == null ? "" : this.arr_FV["GCI"]) +
                        "&f.GPI=" + (this.arr_FV["GPI"] == null ? "" : this.arr_FV["GPI"]) +
                        "&f.GI=" + (this.arr_FV["GI"] == null ? "" : this.arr_FV["GI"]) +
                        "&f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]) 
                    );

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.GTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.GTS_to=" + cts_to;
                    }

                    //this.obj_Comm.ATAGI = this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"];
                    this.obj_Comm.ATAGI = this.arr_FV["SAGI"] != null ? "4-" + this.arr_FV["SAGI"] : (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]);
                    this.obj_Comm.GCI = this.arr_FV["GCI"] == null ? 0 : this.arr_FV["GCI"];
                    this.obj_Comm.GPI = this.arr_FV["GPI"] == null ? 0 : this.arr_FV["GPI"];
                    this.obj_Comm.GI = this.arr_FV["GI"] == null ? 0 : this.arr_FV["GI"];
                    this.obj_Comm.GTS_from = this.arr_FV["DR"]["startDate"] == null ? "" : this.parseDateToJsonString(this.arr_FV.DR.startDate);
                    this.obj_Comm.GTS_to = this.arr_FV["DR"]["endDate"] == null ? "" : this.parseDateToJsonString(this.arr_FV.DR.endDate);
                    this.obj_Comm.CI = this.arr_FV["CI"] == null ? 0 : this.arr_FV["CI"];

                }

                this.getDataApi(`/api/mpromo/lt?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_PTurnover = d.D.Items;
                            that.dec_commAll = 0;

                            that.bool_showGameProviderColumn = that.arr_FV["GPI"] == null ? false : true;
                            that.bool_showGameCategoryColumn = that.arr_FV["GCI"] == null ? false : true;

                            if (that.bool_showGameProviderColumn) {
                                that.bool_showGameCategoryColumn = true;
                            }

                            for (var i = 0; i < that.arr_PTurnover.length; i++) {
                                that.arr_PTurnover[i]['I'] = i + 1;
                                that.arr_PTurnover[i]['bool_sendLoading'] = false;
                                that.arr_PTurnover[i]['bool_sendDisable'] = true;
                                that.arr_PTurnover[i]['str_comm_err'] = "";
                                that.arr_PTurnover[i]['dec_comm'] = 0;
                            }
                            that.resizeTableHead();
                        }
                    });
            },           
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            //UpdateAll function
            updateAllCommission() {
                if (this.dec_commAll >= 0 && !isNaN(parseFloat(this.dec_commAll))) {
                    var updateCount = 0;                    

                    if (this.arr_FV.CT == 1) {
                        //Win Loss
                        for (var i = 0; i < this.arr_PTurnover.length; i++) {
                            if (this.arr_PTurnover[i].WLA < 0) {                                
                                this.arr_PTurnover[i]['dec_comm'] = this.dec_commAll;
                                this.arr_PTurnover[i].CP = parseFloat(this.dec_commAll);
                                this.arr_PTurnover[i].CA = this.dec_commAll * Math.abs(this.arr_PTurnover[i].WLA) / 100.0;
                                this.arr_PTurnover[i].bool_sendDisable = this.dec_commAll == 0;
                                this.arr_PTurnover[i]['str_comm_err'] = "";                                
                                updateCount++;
                            }
                        }                        
                    }
                    else {
                        //Turnover
                        for (var i = 0; i < this.arr_PTurnover.length; i++) {                            
                            this.arr_PTurnover[i]['dec_comm'] = this.dec_commAll;
                            this.arr_PTurnover[i].CP = parseFloat(this.dec_commAll);
                            this.arr_PTurnover[i].CA = this.dec_commAll * this.arr_PTurnover[i].TA / 100.0;
                            this.arr_PTurnover[i].bool_sendDisable = this.dec_commAll == 0;
                            this.arr_PTurnover[i]['str_comm_err'] = "";
                            updateCount++;
                        }
                    }
                    this.str_commAll_err = "";
                    this.bool_sendAllDisable = this.dec_commAll == 0 || updateCount == 0;                    
                }
                else {
                    this.str_commAll_err = String.format(this.getLanguage["ERR"]["1005"], this.getLanguage['PM']['CCP']);                    
                }
            },
            isNullOrWhitespace(input) {
                if (typeof input === 'undefined' || input == null) return true;
                return input.replace(/\s/g, '').length < 1;
            },
            TextValueChange(type, event) {
                if (type == "CNM") {
                    this.obj_Comm.CNM = event.target.value;
                }
            },
            popUpNotif(Id) {
                this.obj_Comm["CNT"] = '';
                this.obj_Comm["CNM"] = '';
                this.int_tempStoreID = Id;

                if (this.checkPermissionAccess2(constAccessType.edit)) {
                    this.bool_isNotifM = true;
                }
                else {
                    this.sentCommisionMainSwitch();
                }

            },
            sentCommisionMainSwitch() {
                var Id = this.int_tempStoreID;
                if (this.isNullOrWhitespace(this.obj_Comm["CNT"])) {                    
                    if (this.arr_FV.CT == 1) {
                        this.obj_Comm["CNT"] = this.getLanguage["PM"]["CNT2"];                        
                    }
                    else {
                        this.obj_Comm["CNT"] = this.getLanguage["PM"]["CNT1"];
                    }
                }
                if (this.isNullOrWhitespace(this.obj_Comm["CNM"])) {
                    if (this.arr_FV.CT == 1) {
                        this.obj_Comm["CNM"] = this.getLanguage["PM"]["CNM2"];
                    }
                    else {
                        this.obj_Comm["CNM"] = this.getLanguage["PM"]["CNM1"];
                    }                    
                }
                if (Id == 0) {
                    this.sendAllCommission()
                } else {
                    this.sendCommission(Id)
                }
            },
            sendAllCommission() {
                this.bool_sendAllDisable = true;
                this.bool_sendAllLoading = true;
                this.bool_fullLoading = true;

                this.obj_Comm.R = [];
                this.obj_Comm["AC"] = this.checkPermissionAccess2(constAccessType.edit) ? 2 : 1;
                this.obj_Comm["CT"] = this.arr_FV["CT"] == 1 ? 2 : 1;

                for (var i = 0; i < this.arr_PTurnover.length; i++) {
                    if (this.arr_PTurnover[i].CA > 0) {
                        this.obj_Comm.R.push({
                            "I": 0,
                            "MI": this.arr_PTurnover[i].MI,
                            "BA": this.arr_FV.CT == 1 ? Math.abs(this.arr_PTurnover[i].WLA) : this.arr_PTurnover[i].BA, 
                            "WLA": Math.abs(this.arr_PTurnover[i].WLA),
                            "T": this.arr_PTurnover[i].TA,
                            "CP": this.arr_PTurnover[i].CP
                        });
                    }
                }
                var that = this;


                this.postDataApi(`/api/mpromo/sc`, this.obj_Comm,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            //that.getPromotionTurnoverList();
                            for (var i = 0; i < that.arr_PTurnover.length; i++) {
                                that.arr_PTurnover[i]['dec_comm'] = 0;
                                that.arr_PTurnover[i].CP = 0;
                                that.arr_PTurnover[i].CA = 0;
                                that.arr_PTurnover[i].bool_sendDisable = true;
                                that.arr_PTurnover[i]['str_comm_err'] = "";
                            }

                            that.bool_sendAllDisable = true;
                            that.bool_sendAllLoading = false;
                            that.bool_isNotifM = false;
                            that.dec_commAll = 0
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            disableUpdate(winlossAmount) {
                return winlossAmount >= 0;
            },
            updateCommission(index) {                
                if (this.arr_PTurnover.length > index) {                    
                    if (this.arr_FV.CT == 1) {                        
                        //Win Loss                        
                        if (this.arr_PTurnover[index].dec_comm >= 0 && this.arr_PTurnover[index].WLA < 0 && !isNaN(parseFloat(this.arr_PTurnover[index].dec_comm))) {                            
                            this.arr_PTurnover[index].CP = parseFloat(this.arr_PTurnover[index].dec_comm);
                            this.arr_PTurnover[index].CA = this.arr_PTurnover[index].dec_comm * Math.abs(this.arr_PTurnover[index].WLA) / 100.0;
                            this.arr_PTurnover[index].bool_sendDisable = this.arr_PTurnover[index].dec_comm == 0 || this.arr_PTurnover[index].CA <= 0;
                            this.arr_PTurnover[index]['str_comm_err'] = "";                            
                        }
                        else {                            
                            this.arr_PTurnover[index]['str_comm_err'] = String.format(this.getLanguage["ERR"]["1005"], this.getLanguage['PM']['CCP']);                            
                        }                       
                    }                    
                    else {
                        //Turnover
                        if (this.arr_PTurnover[index].dec_comm >= 0 && !isNaN(parseFloat(this.arr_PTurnover[index].dec_comm))) {
                            this.arr_PTurnover[index].CP = parseFloat(this.arr_PTurnover[index].dec_comm);
                            this.arr_PTurnover[index].CA = this.arr_PTurnover[index].dec_comm * this.arr_PTurnover[index].TA / 100.0;
                            this.arr_PTurnover[index].bool_sendDisable = this.arr_PTurnover[index].dec_comm == 0 || this.arr_PTurnover[index].CA <= 0;
                            this.arr_PTurnover[index]['str_comm_err'] = "";   
                        }
                        else {
                            this.arr_PTurnover[index]['str_comm_err'] = String.format(this.getLanguage["ERR"]["1005"], this.getLanguage['PM']['CCP']);
                        }
                    }
                    this.$set(this, 'arr_PTurnover', [...this.arr_PTurnover]);
                }
            },

            sendCommission(index) {
                if (this.arr_PTurnover.length > index && this.arr_PTurnover[index].CA > 0) {
                    this.arr_PTurnover[index].bool_sendDisable = true;
                    this.arr_PTurnover[index].bool_sendLoading = true;

                    this.obj_Comm.R = [];
                    this.obj_Comm["AC"] = this.checkPermissionAccess2(constAccessType.edit) ? 2 : 1;
                    this.obj_Comm["CT"] = this.arr_FV["CT"] == 1 ? 2 : 1;

                    this.obj_Comm.R.push({
                        "I": 0,
                        "MI": this.arr_PTurnover[index].MI,
                        "BA": this.arr_FV.CT == 1 ? Math.abs(this.arr_PTurnover[index].WLA) : this.arr_PTurnover[index].BA,
                        "WLA": Math.abs(this.arr_PTurnover[index].WLA),
                        "T": this.arr_PTurnover[index].TA,
                        "CP": this.arr_PTurnover[index].CP                        
                    });
                    this.bool_fullLoading = true;
                    var that = this;

                    this.postDataApi(`/api/mpromo/sc`, this.obj_Comm,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.arr_PTurnover[index]['bool_sendLoading'] = false;

                            if (s) {
                                //that.getPromotionTurnoverList();
                                that.arr_PTurnover[index]['dec_comm'] = 0;
                                that.arr_PTurnover[index].CP = 0;
                                that.arr_PTurnover[index].CA = 0;
                                that.arr_PTurnover[index].bool_sendDisable = true;
                                that.arr_PTurnover[index]['str_comm_err'] = "";
                                that.bool_isNotifM = false;
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                            else {
                            }
                        });
                }
            },
            returnAGI() {
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        return this.dd_agentgroup[0].id.split("-")[1];
                    }
                } else {
                    if (this.arr_FV["AGI"] != null) {
                        var agi = this.arr_FV["AGI"].split("-");
                        agi = agi[1];
                        return agi;
                    } else {
                        return null;
                    }
                }
            },
            clearDD() { //here clear option and select
                this.dd_gameprovider = [];
                this.dd_game = [];

                this.arr_FV["GPI"] = null;
                this.arr_FV["GI"] = null;
            },

            gameCategoryDropDownList() {
                this.clearDD();
                this.loadProviderOptions();
            },

            agentGroupChange(value) {
                this.arr_FV["GCI"] = null;
                this.clearDD();
                this.resizeTableHead();

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
                this.gameCategoryDropDownList();
            },
            loadProviderOptions() {
                var that = this;
                var domainId = 0;
                var gameCategoryId = this.arr_FV["GCI"] == null ? 0 : this.arr_FV["GCI"];
                var agi = 0;
                if (this.searchPAgi == null || this.searchPAgi == 0) {
                    agi = this.curAGI;
                }
                else {
                    agi = this.searchPAgi;
                }

                if (gameCategoryId > 0) {
                    this.getDataApi(`/api/dd/gameProvByCatId/${gameCategoryId}/0/1/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_gameprovider = d.dropdownlist;
                                for (var i = 0; i < that.dd_gameprovider.length; i++) {
                                    that.dd_gameprovider[i].label = that.renderProviderName(that.dd_gameprovider[i].label2);
                                }
                            }
                            else {
                                that.dd_gameprovider = [];
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/dd/gameProv/0/${agi}/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_gameprovider = d.dropdownlist;
                                for (var i = 0; i < that.dd_gameprovider.length; i++) {
                                    that.dd_gameprovider[i].label = that.renderProviderName(that.dd_gameprovider[i].label2);
                                }
                            }
                            else {
                                that.dd_gameprovider = [];
                            }
                        });
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');                

                if (!headerCells.length) return;

                // Check if there are any rows in the body
                const bodyRows = this.$el.querySelectorAll('#tBody .custom-table tbody tr');
                
                if (bodyRows.length === 1 && bodyRows[0].innerText === this.getLanguage['GL']['NR']) {
                    // Set default widths for header cells if there are no records
                    headerCells.forEach(cell => {
                        cell.style.width = ''; // Set a default width, adjust as necessary
                    });
                    return;
                }

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');
                   
                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI"]) {
                    var agentList = this.arr_FV["AGI"].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT == 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },

            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            that.getPromotionTurnoverList();
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getDropdownList();
                    });
            },
            renderClassName(header, data) {
                if (header == 'U') {
                    return "kema-eft";
                }
                else if ((header == 'GC' && !this.bool_showGameCategoryColumn) || (header == 'GP' && !this.bool_showGameProviderColumn)) {
                    return "hidden";
                }
                else if (header == 'PC') {
                    return "pc_width";
                }                             
            },
            resetColumn(headerName) {
                var that = this;                
                var defaultReportHeader = [];
                var reportHeader = [];

                if (that.arr_FV.CT == 1) {
                    defaultReportHeader = that.default_WLReportHeaders;
                    reportHeader = that.report_WLHeaders;
                }
                else {
                    defaultReportHeader = that.default_TReportHeaders;
                    reportHeader = that.report_THeaders;
                }
                
                for (var i = 0; i < defaultReportHeader.length; i++) {
                    that.$set(reportHeader, i, defaultReportHeader[i])
                }
                this.resizeTableHead();
            },            
            removeColumn(headerName,commType) {
                var that = this;                
                var reportHeader = [];
                if (commType == 1) {
                    reportHeader = that.report_WLHeaders;
                }
                else {                    
                    reportHeader = that.report_THeaders;
                }

                const index = reportHeader.indexOf(headerName);    

                if (index > -1)
                    reportHeader.splice(index, 1); 
                                                       
                this.resizeTableHead();                
            },
            removeDefaultColumn(headerName,commType) {
                var that = this;
                var defaultReportHeader = [];
                if (commType == 1) {
                    defaultReportHeader = that.default_WLReportHeaders;
                }
                else {
                    defaultReportHeader = that.default_TReportHeaders;                    
                }
                
                const index = defaultReportHeader.indexOf(headerName);                

                if (index > -1)
                    defaultReportHeader.splice(index, 1);
                                    
                this.resizeTableHead();
            },                     
        },
        created() {            
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.PMCR';
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
            else {
                this.getDropdownList();
                this.getCurrencyList();
            }
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.report_WLHeaders = null;
            this.report_THeaders = null;            
        },        
        watch: {
            getLanguage() {
                this.getPromotionTurnoverList();
            },            
            report_WLHeaders() {
                var that = this;
                if (this.report_WLHeaders == null) {
                    this.getDataApi(`/api/reports/gc/ManualWLCashback`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.report_WLHeaders = [];
                                    for (var i = 0; i < that.default_WLReportHeaders.length; i++) {
                                        if (that.report_WLHeaders.indexOf(that.default_WLReportHeaders[i]) == -1)
                                            that.report_WLHeaders.push(that.default_WLReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.report_WLHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.report_WLHeaders = JSON.parse(d);
                                    }
                                }

                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit))) {
                                    that.removeDefaultColumn('RS',1);
                                    that.removeDefaultColumn('ACT',1);
                                    that.removeColumn('RS',1);
                                    that.removeColumn('ACT',1);
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/ManualWLCashback/` + JSON.stringify(that.report_WLHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.report_WLHeaders != null) {
                    if (that.default_WLReportHeaders.length != that.report_WLHeaders.length)
                        that.needResetWLHeaders = true;
                    else
                        that.needResetWLHeaders = false;
                }                
            },   
            report_THeaders() {
                var that = this;
                if (this.report_THeaders == null) {
                    this.getDataApi(`/api/reports/gc/ManualTRebate`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.report_THeaders = [];
                                    for (var i = 0; i < that.default_TReportHeaders.length; i++) {
                                        if (that.report_THeaders.indexOf(that.default_TReportHeaders[i]) == -1)
                                            that.report_THeaders.push(that.default_TReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.report_THeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.report_THeaders = JSON.parse(d);
                                    }
                                }

                                if (!(that.checkModuleAccess2(constAccessType.edit))) {
                                    that.removeDefaultColumn('CS', 2);
                                    that.removeDefaultColumn('ACT', 2);
                                    that.removeColumn('CS',2);
                                    that.removeColumn('ACT',2);                                    
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/ManualTRebate/` + JSON.stringify(that.report_THeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.report_THeaders != null) {
                    if (that.default_TReportHeaders.length != that.report_THeaders.length)
                        that.needResetTHeaders = true;
                    else
                        that.needResetTHeaders = false;
                }                
            },        
            'arr_FV.CT'(newValue) {
                if (newValue) {
                    this.dec_commAll = 0;
                    this.str_commAll_err = "";
                    this.arr_PTurnover.forEach(item => {
                        item.dec_comm = 0;
                        item.CP = 0;
                        item.CA = 0;
                        item.str_comm_err = "";
                    });                                                           
                    this.resizeTableHead();
                }                              
            },            
        },

    }
</script>

<style>
    .pc_width {
        width: 185px;
        min-width: 185px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/ManualCashbackRebatePromotion.vue